// MAJLIS-164 (ruling 1): the English catalogue, the KEY SOURCE - every key the interface has is a key of this object, and
// every other catalogue is a Record<StringKey, string>. English is in the main bundle (the fallback while another
// catalogue loads); every other language is its own lazily loaded chunk (catalogues/index.ts).
// Moved verbatim from strings.ts (critique 2026-09-19, decision 5): every word the interface says. Status words are here
// too; nothing is hard-coded in a component. No all-caps labels: Arabic has no case, and letter-spacing breaks its joins,
// so labels are set by weight and size.
export const en = {
  appName: "Majlis",
  tagline: "Speak your language. Read yours.",
  modeGroup: "New or existing majlis",
  modeNew: "New majlis",
  modeExisting: "Existing majlis",
  // MAJLIS-171 (the owner-approved screen-rules mock-up, 2026-10-05, frames (f) and (g)): the switch's segment words, without
  // "majlis", at every width (the consultant's ruling 1 of 2026-10-05); modeNew / modeExisting stay as the accessible
  // names. NEW keys (MAJLIS-168), wired after the consultant's verdict of 2026-10-05
  modeNewShort: "New",
  modeExistingShort: "Existing",
  // MAJLIS-168 (the consultant, 2026-10-05): the Passive segment's own short word - in every language but Russian a copy
  // of modePassive (verdict of 2026-10-04 stands); Russian «Слушать», where «Пассивный» did not fit at 320 px
  modePassiveShort: "Passive",
  roomCode: "Majlis code",
  roomCodeHint: "4 letters and numbers, from the person who invited you",
  name: "Your name",
  speak: "I speak",
  read: "I read in",
  thisPhone: "This phone",
  seatPersonal: "Just me",
  seatShared: "Several people on this phone",
  createMajlis: "Create majlis",
  joinMajlis: "Join majlis",
  joining: "Joining…",
  creating: "Starting…",
  errName: "Add your name",
  errCode: "Check the code: 4 letters and numbers",
  errNotFound: "No majlis has this code",
  errClosed: "This majlis has ended",
  errFull: "This majlis is full (8 seats)",
  errRateLimited: "Too many tries. Wait a minute, then try again",
  errServer: "Something went wrong on our side. Try again",
  errReplaced: "This seat is open on another device",
  errOffline: "You're offline",
  // MAJLIS-80 (ruling e): the consultant's text for a person the host removed, verbatim
  errRemoved: "The host removed you from this majlis",
  tryAgain: "Try again",
  modeLive: "Live audio",
  modeScreen: "Screen only",
  // MAJLIS-63 (UI-C17), the consultant's texts of 2026-09-23
  modeNoticeOff: "Live audio is off — everyone reads",
  modeNoticeOn: "Live audio is on",
  // MAJLIS-63: the host-only section (the prototype's "ROOM · HOST ONLY"); MAJLIS-163: the Majlis sheet's section, in the
  // mock-up's word "Host only" (frame (c)); Arabic «للمضيف فقط» (the consultant, 2026-10-04)
  hostOnly: "Host only",
  // MAJLIS-80 (UI-C14 HostControls): "End majlis" and "Remove" are UI-C14's own words; the rest is PROPOSAL, not in
  // the spec or the mock-ups - for the consultant
  hostLinkEntry: "You opened a host link. Join to host this majlis.", // PROPOSAL
  endMajlis: "End majlis",
  endConfirm: "End this majlis for everyone?", // PROPOSAL
  removeSeat: "Remove",
  removeSeatNamed: "Remove {name}", // PROPOSAL (the button's accessible name)
  removeConfirm: "Remove {name} from this majlis?", // PROPOSAL
  cancel: "Cancel", // PROPOSAL
  readingChip: "Reading {lang}. Change the reading language",
  you: "you",
  sharedPhone: "{name}'s phone",
  voiceN: "{name} · voice {n}",
  sharedSeat: "Shared seat",
  // MAJLIS-65 (UI-C16 NameVoiceSheet): "Name this voice", "Name {label}", "Who is speaking?" and "Name" are the approved
  // prototype's words (#voicesheet; its all-caps title set in sentence case, as this catalogue does everywhere). The
  // two accessible names are PROPOSAL, not in the spec or the prototype - for the consultant.
  nameThisVoice: "Name this voice",
  nameVoiceTitle: "Name {label}",
  nameVoicePlaceholder: "Who is speaking?",
  nameVoiceSave: "Name",
  nameVoiceButton: "{label}. Name this voice", // PROPOSAL (the label's accessible name when it can be tapped)
  nameVoiceField: "Name for this voice", // PROPOSAL (the text field's accessible name)
  speaks: "speaks {lang}",
  // MAJLIS-42 / MAJLIS-44 (D-33, D-34, UI-C2, UI-C9, UI-C8): the approved mock-up's strings
  // (docs/spec/prototype/speak-language-mockup.html, marked P there: PROPOSALS the consultant approved with the
  // mock-up on 2026-09-23; none is marked DRAFT).
  speakChoose: "Choose…",
  speakHint: "Your words are written in this language",
  errSpeak: "Choose the language you speak",
  speakRemembered: "Remembered on this phone",
  speakChip: "You speak {lang}. Change the language you speak",
  speakNext: "Takes effect from your next phrase",
  speakShared: "Everyone on this phone is written in this language",
  changing: "Changing…",
  errSpeakChange: "Couldn't change the language. Try again in a moment",
  speakNoticeSelf: "You now speak {lang}",
  speakNoticeOther: "{name} now speaks {lang}",
  change: "Change",
  changeSpeakNamed: "Change the language you speak",
  muted: "muted",
  speaking: "speaking",
  writing: "writing…",
  stillWriting: "still writing…",
  seconds: "{s}s",
  failed: "Couldn't write this one",
  revised: "revised",
  replay: "Replay",
  replayStop: "Stop",
  replayUnavailable: "Replay unavailable",
  replayFailed: "Couldn't play this",
  replayNeedsNewerIOS: "Replay needs a newer iOS",
  replayNeedsNewerBrowser: "Replay needs a newer browser",
  voiceTranslation: "Voice the translation ({lang})",
  translationPending: "The translation follows when the words are final",
  translationComing: "The translation is on its way",
  mute: "Mute",
  listen: "Listen",
  leave: "Leave",
  micDenied: "Microphone blocked. Allow it in your browser settings",
  micUnavailable: "No microphone on this device",
  micUnheard: "We can't hear you – check your connection",
  micMuted: "You're muted",
  micPlaying: "Paused while this phrase plays", // EM-25: the gate, so a quiet ring is explained
  // MAJLIS-71 (D-52, UI-C19, UI-C10): the approved mock-up's words (mic-stopped-mockup.html) - the ring's status line
  // and the mic button's name while the microphone is stopped
  micStopped: "Microphone stopped. Tap to turn it back on",
  micStoppedLabel: "Turn the microphone back on",
  livePaused: "Live audio paused while you replay", // D-38, consultant ruling 1 (UI-C26 to be written)
  tapToHear: "Tap to hear the room", // consultant ruling 2 (UI-C27 to be written); unmeasured on iOS
  // UI-C29 (MAJLIS-88, the owner-approved mock-up): the Listen control's name while Listen is off and another seat
  // speaks, and the first-time hint beside it. The hint text is an ASSUMPTION (UI-C29), the aria wording as drawn.
  listenActivity: "Listen is off. {name} is speaking. Tap to hear them",
  listenHint: "Tap to hear them", // ASSUMPTION (UI-C29)
  // MAJLIS-174 (the screen-rules mock-up, frame (m)): the hint names the control it asks for ({control}: the Listen
  // label itself, so the two always read the same). NEW key (MAJLIS-168), verdict PASS 2026-10-05
  listenHintTap: "Tap {control} to hear them",
  reconnecting: "Reconnecting…",
  offlineReconnecting: "You're offline. Reconnecting…",
  writingPaused: "Writing is paused. Reconnecting…",
  writingAgain: "Writing again",
  // MAJLIS-113 (UI-C33, UI-C34): the isolator's compare mode, the approved mock-up's words (compare-mode-mockup.html)
  compareLabel: "Compare",
  compareBanner: "Compare mode is on for this phone only · testing, not stored",
  isolatorTag: "isolator",
  isolatorEmpty: "(nothing)",
  isolatorPending: "isolator: appears once this phrase is final",
  jumpSpeaking: "{name} is speaking",
  jumpNew: "{n} new",
  jumpLive: "Back to live",
  canvas: "Conversation",
  canvasEmpty: "The conversation appears here",
  // MAJLIS-89 (P-19): the mock-up's words (record-mockup.html 5a, PROPOSAL for the consultant): the marker above the
  // phrases a join is handed, and the divider where live begins ({t}: the join's time on this phone)
  // Counted: one key per plural category (i18n `plural`, the consultant's forms of 2026-09-24); English has two forms,
  // written out for every category so each language's table is complete.
  earlierMarker_one: "Earlier · the last phrase",
  earlierMarker_two: "Earlier · the last {n} phrases",
  earlierMarker_few: "Earlier · the last {n} phrases",
  earlierMarker_many: "Earlier · the last {n} phrases",
  earlierMarker_other: "Earlier · the last {n} phrases",
  liveHere: "Live from here · {t}",
  farewell: "You left the majlis",
  farewellBody: "Thank you for sitting with us.",
  rejoin: "Rejoin",
  startAgain: "Back to the start",
  close: "Close",
  searchLanguages: "Search languages",
  noLanguage: "No language matches",
  invite: "Invite people with this link",
  hostLink: "Your host link, shown only once. Keep it.",
  copy: "Copy",
  copied: "Copied",
  // MAJLIS-64 interpreter mode (UI-C21..C24, UI-C6): the approved mock-ups' words (docs/spec/prototype/
  // interpreter-mode-mockups.html, owner "GO" 2026-09-23), verbatim where the mock-up gives them. Where the mock-up
  // prints an English screen with an Arabic companion (the sheet title, the options, "N behind", the mic hint) the room
  // composes it from both catalogues and MOCKUP_ARABIC_LINES below. Arabic words the mock-up does not give are marked
  // PROPOSAL in the Arabic catalogue.
  listenTitle: "Listen",
  listenChoice: "Listen: {mode}. Choose how you listen",
  listenTranslated: "Translated",
  listenTranslatedBody: "Each phrase is spoken to you in {lang}, in order. Live voices are lowered underneath.",
  // MAJLIS-64, consultant ruling 2026-09-23: on iOS the live voices are MUTED under a voice (volume is ignored there).
  listenTranslatedBodyIOS: "Each phrase is spoken to you in {lang}, in order. Live voices are muted underneath.",
  listenOriginal: "Original",
  listenOriginalBody: "Hear people's real voices only. Translations stay as text.",
  liveUnderRow: "While a phrase is spoken, live voices are",
  liveUnderHint: "lowered (default) · muted for noisy places",
  liveUnderSwitch: "Mute live voices while a phrase is spoken",
  liveUnder: "live voices {state}",
  liveLowered: "lowered",
  liveMuted: "muted",
  voiceCapped: "text only, voice on tap",
  speakingToYou: "Speaking to you",
  behind: "{n} behind",
  catchUp: "Catch up",
  micListening: "Mic paused while listening — tap to speak",
  // MAJLIS-67 (the record, UI-S3, UI-C13): the approved mock-up's words (docs/spec/prototype/record-mockup.html, its
  // footer table, every one marked P there - a PROPOSAL until the consultant confirms). The last four are not in the
  // mock-up at all (states it does not draw) and are PROPOSAL here.
  // MAJLIS-66 restores the mock-up's full line (67 had it without the read-link clause until read links existed)
  endedHostBody: "The record is kept. Only you can open it; share it with read links.",
  openRecord: "Open the record",
  myMajlis: "My majlis",
  myMajlisHint: "Records of the majlis you hosted",
  myMajlisCount: "{label}, {n}",
  // MAJLIS-145: counted (i18n `plural`) - "1 seat", "2 seats"
  rowMeta_one: "{min} min · {n} seat",
  rowMeta_two: "{min} min · {n} seats",
  rowMeta_few: "{min} min · {n} seats",
  rowMeta_many: "{min} min · {n} seats",
  rowMeta_other: "{min} min · {n} seats",
  back: "Back",
  hostedByYou: "Hosted by you",
  started: "Started {t}",
  ended: "Ended {t}",
  search: "Search this record",
  endSearch: "Close search",
  matchOf: "{i} of {n}",
  prevMatch: "Previous match",
  nextMatch: "Next match",
  recordLoading: "Opening the record…", // PROPOSAL (not in the mock-up)
  recordFailed: "Couldn't open the record", // PROPOSAL (not in the mock-up)
  recordsNone: "No finished majlis yet", // PROPOSAL (not in the mock-up)
  noMatch: "No match", // PROPOSAL (not in the mock-up)
  // MAJLIS-37 (UI-C14, D-30; UI-C30..C32 PROPOSED): the room lock, in the words of the owner-approved mock-up
  // (docs/spec/prototype/room-lock-mockup.html, 2026-09-24), verbatim. Every one is marked P (PROPOSAL) there: DRAFT
  // wording until the consultant's spec row fixes it.
  lockRoom: "Lock the room",
  lockOff: "Anyone with the code can join",
  lockOn: "New people wait until you let them in",
  locked: "Locked",
  knockWants: "wants to join",
  approve: "Approve",
  deny: "Deny",
  approveNamed: "Approve {name}",
  denyNamed: "Deny {name}",
  knockSay: "{name} wants to join. Speaks {lang}.",
  waitingToJoin: "Waiting to join ({n})",
  moreWaiting: "{n} more waiting",
  waitTitle: "Waiting for the host to let you in",
  waitBody: "Majlis {code} is locked. The host sees your name and your language, nothing else.",
  errDenied: "The host didn't let you in",
  deniedBody: "You can ask the host to let you in, then try again later.",
  hostAway: "The host isn't in the majlis right now. You can keep waiting.",
  errKnockTimeout: "No answer from the host",
  knockTimeoutBody: "Nobody let you in within 5 minutes.",
  // MAJLIS-66 (read links, the options sheet, delete; UI-C14, UI-C15, UI-S3): the approved mock-up's words, verbatim
  // (its footer table; each a PROPOSAL there until the consultant confirms). Reused as they are: copy, copied, cancel,
  // close, back, startAgain.
  rowLinks: "Read links: {n}",
  openedHere: "Opened here with a read link",
  recordMenu: "Record options",
  share: "Share the record",
  linkUnnamed: "Read link",
  linkCreated: "Created {d}",
  revokeNamed: "Turn off {label}",
  revoke: "Turn off",
  revoked: "Turned off {d}",
  shareBody: "A read link opens this record, read only. You can turn any link off.",
  newLink: "New read link",
  linkName: "Name (only you see it)",
  linkOnce: "Copy it now. It is shown only once.",
  revokeConfirm: "Turn off this link? Whoever has it can no longer open the record.",
  deleteConfirm: "Delete this record for everyone?",
  deleteWhat:
    "Deleted for good: the text, every translation and every recording of this majlis. Every read link stops working. This cannot be undone.",
  deleteRecord: "Delete record",
  recordHostOnly: "Record · host only",
  deleted: "Record deleted",
  readOnly: "Read only · shared by the host",
  // MAJLIS-153 (D-60; UI-C40, UI-C41, UI-C42): the record's summary, in the spec rows' words verbatim. The two
  // accessible names of the header block's people and languages are the approved mock-up's (summary-mockup.html (b)).
  summary: "Summary",
  summaryRecap: "Quick recap",
  summaryTopics: "Topics",
  summaryDecisions: "Decisions",
  summaryActions: "Action items",
  summaryQuestions: "Open questions",
  summaryMoments: "Notable moments",
  summaryMoment: "Go to this phrase in the record: {name}, {time}",
  summaryGenerated: "Generated by Majlis. Check it before relying on it.",
  summaryWriting: "Writing the summary…",
  summaryWritingHint: "The first time takes a little while. After that it opens at once.",
  summaryFailed: "Couldn't write the summary",
  // MAJLIS-170 (the screen-rules mock-up, frame (c)): the one muted line under the failure. NEW key (MAJLIS-168), verdict PASS 2026-10-05
  summaryFailedBody: "The majlis and its record are safe.",
  summaryTooShort: "This majlis is too short to summarise.",
  summaryMinutes: "{min} min",
  summaryPeople: "People",
  nameSep: ", ", // between people's names (MAJLIS-154, consultant 2026-10-02: the app had no Arabic list separator)
  summaryLangs: "Languages",
  // MAJLIS-154 (UI-C41, ruling 4): the summary's "Save as file", the row's words; its failure line is PROPOSED wording
  // (the row asks for a visible line and names none; the consultant confirms it)
  summarySave: "Save as file",
  summarySaveFailed: "Couldn't save the file",
  askHostBody: "Ask the host for a link to the record.",
  linkDeadTitle: "This record can't be opened",
  linkDeadBody: "Ask the host for a new link.",
  actionFailed: "Something went wrong on our side. Try again", // PROPOSAL: errServer's words (not drawn in the mock-up)
  // MAJLIS-126 (D-55, UI-C35, UI-C36): Your rooms and Listed rooms, in the words of the owner-approved mock-up
  // (docs/design/rooms-list-mockup-2026-09-25.html, its footer table), verbatim; the wording (ruling 5) is the
  // consultant's of 2026-09-26. Reused as they are: errNotFound, errFull, modeExisting, roomCode, locked, joinMajlis.
  yourRooms: "Your rooms",
  yourRoomsHint: "On this phone only",
  listedRooms: "Listed rooms",
  listedRoomsHint: "Anyone who opens the app sees these",
  roleHost: "You host",
  roleGuest: "You joined",
  seatedN: "{n} seated",
  hostedBy: "Hosted by {name}",
  kindOpen: "Open",
  kindKey: "Code needed",
  kindFull: "Full",
  // MAJLIS-145 (UI-C35, consultant 2026-09-30): Your rooms lists OPEN rooms only (an ended one is in My majlis), each
  // with its start time: "Today · {t}", "Yesterday · {t}", else My majlis's own "{day} · {t}".
  startedToday: "Today · {t}",
  startedYesterday: "Yesterday · {t}",
  defaultRoomName: "{name}'s majlis",
  noYourRooms: "Rooms you host or join appear here, on this phone only.",
  noListedRooms: "No listed rooms right now.",
  showAll: "Show all ({n})",
  askCode: "Ask {name} for the code",
  notThisRoom: "Not this room",
  listedMark: "Listed",
  roomList: "Room list",
  unlisted: "Unlisted",
  unlistedHint: "Only people with the code find it",
  listedOpen: "Listed open",
  listedOpenHint: "Anyone can join from the list",
  listedKey: "Listed with key",
  listedKeyHint: "In the list; joining needs the code",
  openLocked: "Unlock the room to list it open",
  roomName: "Room name",
  listingPrivacy: "Anyone who opens the app sees this name and yours. Never the code.",
  // MAJLIS-ADMIN (UI-C37, PROPOSED): the owner's read-only admin view
  adminTitle: "Admin",
  adminPassword: "Admin password",
  adminEnter: "Open",
  adminUnavailable: "Not available",
  adminRefresh: "Refresh",
  adminEmpty: "No rooms yet",
  adminOpen: "Open",
  adminClosed: "Closed",
  adminDeleted: "Deleted",
  adminCreated: "Created",
  adminHost: "Host",
  adminSeated: "In now",
  adminSeats: "People",
  adminPhrases: "Phrases",
  adminLast: "Last activity",
  adminDelete: "Delete this room",
  adminDeleteConfirm: "Delete everything in this room for good? This cannot be undone.",
  adminDeleteYes: "Delete for good",
  adminDeleteNo: "Cancel",
  adminDeleteDone: "The room was deleted",
  adminDeleteOpen: "This room is still open. It can be deleted an hour after the last person leaves.",
  adminDeleteFailed: "The room could not be deleted. Try again.",
  // MAJLIS-176 (UI-C37; the owner-approved admin mock-up of 2026-10-06): the admin screens redrawn. NEW keys, held back
  // by i18n/pending.ts until the consultant's verdict (docs/i18n/new-keys-2026-10-06.md)
  adminSignIn: "Every majlis on this server, with its record.",
  adminFootnote: "This page is not linked from the app. The password is kept only while this tab is open.",
  adminShowPassword: "Show password",
  adminHidePassword: "Hide password",
  adminLock: "Lock",
  adminUpdatedNow: "updated just now",
  adminUpdated: "updated {time}",
  adminOpenNow: "Open now",
  adminPeopleIn: "People in rooms",
  adminRooms: "Rooms",
  adminSearch: "Search by name or host",
  adminAll: "All",
  adminState: "State",
  adminInNow: "{n} in now · {m}",
  adminInAll: "{n} in all",
  adminRemoved: "record removed",
  adminNewest: "Newest first",
  adminCount: "{n} of {total}",
  adminEmptyBody: "The first majlis on this server will appear here.",
  adminDeleteNamed: "Delete {name} for good?",
  adminDeleteBody: "The record, its audio and the summary are removed for everyone. This cannot be undone.",
  // MAJLIS-137 (D-57, UI-C38, UI-C39; passive mode phase 1, the owner-approved mock-up docs/spec/prototype/
  // passive-mode-mockup.html, its footer table; wording ruled by the consultant 2026-09-29)
  modePassive: "Passive",
  passiveHint: "Listen to the room and read it in your language",
  passiveStart: "Start",
  voiceBare: "Voice {n}",
  autoPlay: "Auto-play translations",
  autoPlayShort: "Auto-play",
  autoPlayHint: "Translations are silent. Turn on Auto-play to hear them",
  // MAJLIS-140 (D-59, P-39, condition 5): the passive voice track could not play - the line on the switch
  playbackUnavailable: "Playback unavailable",
  // MAJLIS-163 (UI-C10, UI-S2/UI-C8, UI-C14 amended; the owner-approved mock-up docs/spec/prototype/
  // room-controls-mockup.html, frames (a)-(f)). English: the mock-up's words. Arabic: the mock-up's AR frames
  // verbatim, or the catalogue's own; what the mock-up lacks is the consultant's formal Arabic of 2026-10-04.
  // the one-word label under the mic follows the action (consultant 2026-10-04): Mute while live, Unmute while muted
  // (its accessible name stays `mute`, with aria-pressed)
  muteLabel: "Mute",
  unmuteLabel: "Unmute",
  people: "People · {n}", // the bar's label, the People sheet's title, and the accessible name of both openers
  peopleCount_one: "{n} person",
  peopleCount_two: "{n} people",
  peopleCount_few: "{n} people",
  peopleCount_many: "{n} people",
  peopleCount_other: "{n} people",
  majlisSettings: "Majlis {code}, settings", // the title button's accessible name (the consultant's ruling 3)
  majlisTitle: "Majlis {code}",
  startedHost: "Started {t} · you are the host",
  inMajlis: "In the majlis",
  leaveTitle: "Leave {code}?",
  hostYou: "You are the host",
  leaveHint: "The majlis continues without you. You can come back.",
  endForEveryone: "End majlis for everyone",
  endForEveryoneHint: "Everyone leaves. The record is kept for you.",
} as const;

export type StringKey = keyof typeof en;
